// console.log("CL44");
async function updateCartItem(itemId, quantity) {
    await $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: { [itemId]: quantity }
        },
        dataType: 'json',
        async: false
    });
   setTimeout(function() {
   jQuery.getJSON('/cart.js', function(cart) {
        let cartData = cart.items;
        document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
             detail: cartData
        })); 
   });
   }, 400); 
}

async function addItem(variantId, quantity) {
  try {

    // Fetch current cart contents
    const cartResponse = await fetch("/cart.js");
    const cartData = await cartResponse.json();

    // Check if the item is already in the cart
    const itemInCart = cartData.items.find(item => item.variant_id === variantId);

    if (itemInCart) {
      console.log("Item is already in the cart.");
      return;
    }
    
    const response = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to add item to cart: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    console.log("Item added to cart:", result);
    myFunction();
    
  } catch (error) {
    console.error("An error occurred:", error);
  }
}

var myFunction = function() {
    getCart().then(function(result) { 
      console.log(result);
      var freeGiftAdded=false;
      var swimmerRegimeAdded=false;
      var freePouchAdded = false;
      var freeCombAdded = false;
      var miniAdded = false;
      var cart = result;
      var monsoonDuoAdded = false;
      var freeMiniTubeAdded=false;
      var freeXmasGiftAdded=false;
      var freeMiniTubeBottle =false;
      var freeNewCombAdded=false;
      var refillPackAdded=false;
      var freePouchWithSwimmerDuoAdded=false;
      var swimmerDuoAdded=false;
      var freeItems = 0;

      if(cart.total_price<299){
         $(".cart__checkout").prop('disabled', true);
         $(".cart__checkout").text('Invalid Order');
      }
      else{
        $(".cart__checkout").prop('disabled', false);
        $(".cart__checkout").text('Checkout');
      }
      
      var item_count = cart.item_count;
      var subTotal = cart.total_price;
      var strTotal = String(subTotal);
      var str_total = strTotal.substring(0, strTotal.length - 2);
      console.log("subTotal = "+subTotal + " and str_total = "+str_total);

      //////////////////// cart footer label code for buy 2 get 1
      // if (item_count < 3) {
      //   document.getElementById("cart_footer_label").style.display = "block";
      // } else {
      //   document.getElementById("cart_footer_label").style.display = "none";
      // }

      // freebie for 1999
        // if (subTotal >= 199900) {
        //    updateCartItem("50492053356845", 1);
        // }else{
        //   updateCartItem("50492053356845", 0);
        // }
       function checkDiscount() {

    fetch('/cart.js').then(response => response.json()).then(cartData => {

        if (cartData.total_discount > 0) {

          // Display message that a discount is applied

          updateCartItem("50492053356845", 0);
          console.log("discounted");

        } else {

          // Display message that no discount is applied
        if (subTotal >= 199900) {
           updateCartItem("50492053356845", 1);
          console.log("added freebie");
          
        }else{
          updateCartItem("50492053356845", 0);
          
          console.log("removed freebie");
          
        }
          console.log("No discount applied");

        }

      });

  }



  // Call the checkDiscount function on page load or when the cart changes

  // checkDiscount();
      
      // christmas offer for freebies
      // const cartFooterText = document.querySelector("#cart_footer_label > p");

      //   function updateCartBulk(updates) {
      //       $.ajax({
      //           type: 'POST',
      //           url: '/cart/update.js',
      //           data: { updates },
      //           dataType: 'json',
      //           async: false,
      //           success: function(response) {
      //               console.log("Cart updated successfully", response);
      //           },
      //           error: function(xhr, status, error) {
      //               console.error("Error updating cart:", error);
      //           }
      //       });
      //   }
        
      //   function updateCartState(subTotal) {
      //       const cartUpdates = {
      //           "50298362560813": 0, // Free Mini Hair Moisturiser 10ml Tube
      //           "50298368065837": 0, // Free 50ml Co-Wash Pouch Pack
      //           "50298373931309": 0  // Free Scalp Tonic
      //       };
        
      //       let message = "";
            
      //       if (subTotal >= 202500) {
      //           console.log("Subtotal above 2025");
      //           cartUpdates["50298373931309"] = 1;
      //           document.getElementById("cart_footer_label").style.display = "none";
      //       } else {
      //           document.getElementById("cart_footer_label").style.display = "block";
                
      //           if (subTotal >= 142500) {
      //               console.log("Subtotal between 1425 and 2025");
      //               cartUpdates["50298368065837"] = 1;
      //               message = `Order for Rs. ${(202500 - subTotal) / 100} more to get a FREE Scalp Tonic 100ml`;
      //           } else if (subTotal >= 72500) {
      //               console.log("Subtotal between 725 and 1425");
      //               cartUpdates["50298362560813"] = 1;
      //               message = `Order for Rs. ${(142500 - subTotal) / 100} more to get a FREE 50ml Co-Wash Pouch Pack`;
      //           } else {
      //               console.log("Subtotal below 725");
      //               message = `Order for Rs. ${(72500 - subTotal) / 100} more to get a FREE Mini Hair Moisturiser 10ml Tube`;
      //           }
      //       }
        
      //       updateCartBulk(cartUpdates);
      //       if (cartFooterText) cartFooterText.innerText = message;
            
      //   }
        
      //   if (item_count > 0) {
      //       document.getElementById("cart_footer_label").style.display = "block";
      //   }
        
      //   updateCartState(subTotal);

       // christmas offer ends
      
      for (var i = 0; i < cart.items.length; i++) {

        if(cart.items[i].price == 0){
          freeItems++;
        }

        if(cart.items[i].price <= 0 && cart.items[i].quantity >1){
          var itemId = cart.items[i].id; // Get the item ID

          console.log(itemId + "price "+cart.items[i].price +" is 0 and gift product added more than once");
      
              // Make the AJAX request
              $.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: {
                      updates: {
                          [itemId]: 0 
                      }
                  },
                  dataType: 'json',
                  async: false,
                  success: function(response) {
                      // Handle success response here if needed
                  },
                  error: function(xhr, status, error) {
                      // Handle error response here if needed
                  }
              });
        }
        //freebie removal code
        if(cart.items[i].title.startsWith("Free") && cart.items[i].price <= 32500 && cart.items.length <= 1){
          var itemId = cart.items[i].id; // Get the item ID

          console.log(itemId + " Removed freebie");
      
              // Make the AJAX request
              $.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: {
                      updates: {
                          [itemId]: 0 
                      }
                  },
                  dataType: 'json',
                  async: false,
                  success: function(response) {
                      // Handle success response here if needed
                  },
                  error: function(xhr, status, error) {
                      // Handle error response here if needed
                  }
              });
        }

        if((cart.items[i].id == '49659021328685' || cart.items[i].id == '48066898690349') && cart.items.length <2){
           console.log('removing paid neem comb or empty bottle as it is only item added');
          $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "49659021328685":0,
                    "48066898690349":0
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
        }

        if(cart.items[i].id == '48941178650925')
        {
          freePouchWithSwimmerDuoAdded = true;
        }
        
        //alert(cart.items[i].id);
        //alert(freePouchWithSwimmerDuoAdded);
        //Add Free pouch with Swimmer's Hair Care Duo
        //if(cart.items[i].id == '45074455494957' && freePouchWithSwimmerDuoAdded==false)
        // if(cart.items[i].id == '45074455494957' || cart.items[i].id == '46694674858285' || cart.items[i].id == '49742570225965') 
        // {
        //     //alert(cart.items[i].id);
        //    swimmerDuoAdded = true;
        //    // addItem('48941178650925');

        //   $.ajax({
        //        type: 'POST',
        //        url: '/cart/update.js',
        //        data: {
        //          updates:{
        //             "48941178650925":1
        //          }
        //        },
        //        dataType: 'json',
        //        async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
        //      });
        //    freePouchWithSwimmerDuoAdded = true;
        // }

        // if(cart.items[i].id == '48941178650925') 
        // {
        //   $.ajax({
        //        type: 'POST',
        //        url: '/cart/update.js',
        //        data: {
        //          updates:{
        //             "48941178650925":0
        //          }
        //        },
        //        dataType: 'json',
        //        async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
        //      });
        // }
        
        
        
        // if(swimmerDuoAdded==false){
        //   $.ajax({
        //        type: 'POST',
        //        url: '/cart/update.js',
        //        data: {
        //          updates:{
        //             "48941178650925":0
        //          }
        //        },
        //        dataType: 'json',
        //        async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
        //      });
        //  }


        
        
          if (cart.items[i].quantity > 10) {
              var itemId = cart.items[i].id; // Get the item ID
      
              // Make the AJAX request
              $.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: {
                      updates: {
                          [itemId]: 10 
                      }
                  },
                  dataType: 'json',
                  async: false,
                  success: function(response) {
                      // Handle success response here if needed
                  },
                  error: function(xhr, status, error) {
                      // Handle error response here if needed
                  }
              });
      
              swal("The Earth Collective", "Max quantity per product is 10.", "error");
          }
        
        

        if(cart.items[i].id == '48066869231917'){
          refillPackAdded=true;
          console.log('1 now refillPackAdded = '+refillPackAdded);
        }
        if(cart.items[i].id == '48066873327917'){
          refillPackAdded=true;
          console.log('2 now refillPackAdded = '+refillPackAdded);
        }
        
        // if(refillPackAdded==true){
        //   console.log('adding free new comb.');
        //   $.ajax({
        //        type: 'POST',
        //        url: '/cart/update.js',
        //        data: {
        //          updates:{
        //             "49208284315949":1
        //          }
        //        },
        //        dataType: 'json',
        //        async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
        //      });
        //   freeNewCombAdded==true;
        // }

        // if(cart.items[i].id == '49208284315949'){
        //   freeNewCombAdded=true;
        //   console.log('paras freeNewCombAdded = '+freeNewCombAdded);

        //   if(refillPackAdded==false){
        //     console.log('paras removed removing the free comb ');
        //     $.ajax({
        //          type: 'POST',
        //          url: '/cart/update.js',
        //          data: {
        //            updates:{
        //               "49208284315949":0
        //            }
        //          },
        //          dataType: 'json',
        //          async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
            
        //        });
        //   }
          
        // }
        
        if(cart.items[i].id == '45074455494957'){
              swimmerRegimeAdded = true; 
        }

        if(cart.items[i].id == '45498897367341'){
              monsoonDuoAdded = true; 
          }

        if(cart.items[i].id == '45556561969453'){
              freeCombAdded = true; 
        }
        if(cart.items[i].id == '46288507339053'){
        	freeMiniTubeAdded=true;
        	
        }
        if(cart.items[i].id == '47766086254893'){
          freeXmasGiftAdded=true;
        }
        // console.log('freeMiniTubeAdded = '+freeMiniTubeAdded);
        
        // var doubleValueTotal = str_total ? parseFloat(str_total) : 0;
        if (cart.items[i].id == '47436880281901') {
            console.log('removing free item 1.');

          $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "47436880281901":0
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
            
        }

        if (cart.items[i].id == '47436886016301') {
            console.log('removing free item 1.');

          $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "47436886016301":0
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
            
        }



        // console.log('doubleValueTotal = '+doubleValueTotal);
        
        // if(cart.items[i].id == '46288507339053' && doubleValueTotal < 299 ){
        
        //             $.ajax({
        //                type: 'POST',
        //                url: '/cart/update.js',
        //                data: {
        //                  updates:{
        //                     "46288507339053":0
        //                  }
        //                },
        //                dataType: 'json',
        //                async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
                  
        //              });
                    
        // }
        
        // if(cart.items[i].id == '46288507339053' && cart.items[i].quantity >1){
        
        //             $.ajax({
        //                type: 'POST',
        //                url: '/cart/update.js',
        //                data: {
        //                  updates:{
        //                     "46288507339053":1
        //                  }
        //                },
        //                dataType: 'json',
        //                async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
                  
        //              });
                    
                   
        // }
        
        
          if(cart.items[i].id == '45085409509677' && cart.items[i].quantity >1){

            $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "45085409509677":1
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
            
            swal("The Earth Collective", "Quantity can't be increased for the gift products.", "error");
            // $(".cart__checkout").prop('disabled', true);
            // $(".cart__checkout").text('Invalid Order');
            // break;
          }
          else if(cart.items[i].id == '45018499350829' && cart.items[i].quantity >1){

            $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "45018499350829":1
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
            
            swal("The Earth Collective", "Quantity can't be increased for the gift products.", "error");
            // $(".cart__checkout").prop('disabled', true);
            // $(".cart__checkout").text('Invalid Order');
            // break;
          }
          else{
            // $(".cart__checkout").prop('disabled', false);
            // $(".cart__checkout").text('Checkout');
          }
//paras
        if(cart.items[i].id == '45556561969453' && cart.items[i].quantity >1){

            $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "45556561969453":1
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
            
            swal("The Earth Collective", "Quantity can't be increased for the gift products.", "error");
            // $(".cart__checkout").prop('disabled', true);
            // $(".cart__checkout").text('Invalid Order');
            // break;
          }
          
          if(cart.items[i].id == '45085409509677'){
              freeGiftAdded = true; 
          }
          if(cart.items[i].id == '45074455494957'){
              swimmerRegimeAdded = true; 
          }
        
          if(cart.items[i].id == '45018499350829'){
              freePouchAdded = true; 
          }
        
          if(cart.items[i].id == '45009727521069'){
              miniAdded = true; 
          }
          if(cart.items[i].id == '45009769169197'){
              miniAdded = true; 
          }
          if(cart.items[i].id == '44756534165805'){
              miniAdded = true; 
          }
          if(cart.items[i].id == '44756543111469'){
              miniAdded = true; 
          }

          if(cart.items[i].id == '47979506532653'){
              freeMiniTubeBottle = true; 
          }
      }
      // add free travel pouch with minis free travel pouch id = 45018499350829
      if(miniAdded == true){
        $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "45018499350829":1
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
      }


      // Check if the <h5> element with id "myCustomMsg" exists
      // var myCustomMsgElement = document.getElementById('myCustomMsg');
      // if (myCustomMsgElement) {
      //   var subtotal = str_total; 
        
      //   if(item_count-freeItems > 1 ){
      //     myCustomMsgElement.textContent = 'Yay! Buy 2 Get 20% off Sitewide Offer Applied';
      //     if(freeMiniTubeBottle==false){
      //       addItem(47979506532653,1);
      //     }
      //   }
      //   else if(item_count-freeItems == 1){
      //     myCustomMsgElement.textContent = 'Add 1 more product to get 20% off'
      //   }
      //   else{
      //     myCustomMsgElement.textContent = 'My Cart';
          
      //   }
      // }
      

      console.log('paras checking refillPackAdded = '+refillPackAdded + " and freeNewCombAdded = "+freeNewCombAdded);

      

      if(freeNewCombAdded==true && refillPackAdded == false){

            console.log('removing free comb item 1.');
            console.log('refillPackAdded = '+refillPackAdded);
            console.log('freeNewCombAdded = '+freeNewCombAdded);
  
            $.ajax({
                 type: 'POST',
                 url: '/cart/update.js',
                 data: {
                   updates:{
                      "48106222190893":0
                   }
                 },
                 dataType: 'json',
                 async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
            
               });
            
        }
      
      if(freeGiftAdded==true && swimmerRegimeAdded==false)
      {
          $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "45085409509677":0
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
      }

      // console.log('freeCombAdded = '+freeCombAdded + " and monsoonDuoAdded = "+monsoonDuoAdded);

      if(freeCombAdded==true && monsoonDuoAdded==false)
      {
          $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "45556561969453":0
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
      }

      // console.log('freePouchAdded = '+freePouchAdded + " and miniAdded = "+miniAdded);
      
      if(freePouchAdded==true && miniAdded==false)
      {
          $.ajax({
               type: 'POST',
               url: '/cart/update.js',
               data: {
                 updates:{
                    "45018499350829":0
                 }
               },
               dataType: 'json',
               async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
          
             });
      }

      document.dispatchEvent(new CustomEvent('cart:build', {
          detail: {
            cart: cart
           
          }

        
       }));
        
       // console.log('cart updated...');
      
    })
};

document.addEventListener("DOMContentLoaded", function() {
  // console.log('Page Loaded...');


    var elements = document.getElementsByClassName("cart__checkout");
    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', myFunction, false);
    }
  
    document.addEventListener('cart:updated', function (evt) {
      console.log('Cart updated');
      console.log(evt.detail.cart);
      myFunction();

    });

    $(document).on("ajaxProduct:added", function() {
      // Add your customizations
       console.log('paras event ajaxProduct:added');
       myFunction();
    });


  myFunction();
  
});

async function getCart() {
      const result = await fetch("/cart.json");
  
      if (result.status === 200) {
          return result.json();
      }
  
      throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  }